/**
 * Created by hp on 2017/7/14.
 */
const defaults = {
    totalInitialized: false,
    promoteInitialized: false,
    inviteInitialized: false,
    newOldInitialized: false,
    sexualInitialized: false,
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'DATACENTER_INIT_DEFAULT':
            return defaults;
        case 'DATACENTER_TOTAL_INIT':
            return {...state, totalInitialized: true, ...action.payload};
        case 'DATACENTER_PROMOTE_INIT':
            return {...state, promoteInitialized: true, ...action.payload};
        case 'DATACENTER_INVITE_INIT':
            return {...state, inviteInitialized: true, ...action.payload};
        case 'DATACENTER_INVITE_MORE':
            return {...state, ...action.payload};
        case 'DATACENTER_COMPLETE_RATE_INIT':
            return {...state, ...action.payload};
        case 'DATACENTER_NEW_OLD_RATE_INIT':
            return {...state, newOldInitialized: true, ...action.payload};
        case 'DATACENTER_SEXUAL_RATE_INIT':
            return {...state, sexualInitialized: true, ...action.payload};
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/dataCenter.js